export const currencyFormatMixin = {
  methods: {
    formatCurrencyByCountry(amount) {
      const countryConfig = this.getCountryCurrencyConfig()

      if (countryConfig.useExactValue) {
        // Formato personalizado para países específicos
        // Asegurar que siempre se muestren dos decimales
        let value = (amount / 1).toFixed(2)
        value = value.replace('.', countryConfig.decimalSeparator)
        return `${countryConfig.symbol}${value.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          countryConfig.thousandsSeparator
        )}`
      }

      // Formato estándar para otros países
      return this.$options.filters.currency(amount, countryConfig.decimals, countryConfig.symbol)
    },

    getCountryCurrencyConfig() {
      const countryCode = this.country_code?.toLowerCase()

      const configs = {
        co: {
          symbol: '$',
          decimals: 0,
          useExactValue: true,
          decimalSeparator: ',',
          thousandsSeparator: '.'
        },
        pe: {
          symbol: 'S/',
          decimals: 2,
          useExactValue: false,
          decimalSeparator: ',',
          thousandsSeparator: '.'
        },
        mx: {
          symbol: '$',
          decimals: 2,
          useExactValue: true,
          decimalSeparator: ',',
          thousandsSeparator: '.'
        },
        cl: {
          symbol: '$',
          decimals: 0,
          useExactValue: false,
          decimalSeparator: ',',
          thousandsSeparator: '.'
        }
      }

      return (
        configs[countryCode] || {
          symbol: '$',
          decimals: 0,
          useExactValue: false,
          decimalSeparator: ',',
          thousandsSeparator: '.'
        }
      )
    }
  }
}
